export default "__VITE_ASSET__qxPgwygY__"